import { AppConfig } from '@app/core-bundle/config/app-config';

function init(setDomainUserId) {
  if (!window.__snowplow__) {
    return;
  }

  window.__snowplow__('newTracker', 'co', window.__snowplow__.collector, {
    bufferSize: 1,
    post: true,
    encodeBase64: false,
    respectDoNotTrack: true,
    userFingerprint: false,
    appId: 'transfer_core',
    platform: 'web',
    stateStorageStrategy: 'cookie', // To get past ITP2.1, cookies are set or reset by the server
    contexts: {
      webPage: true,
    },
    cookieName: AppConfig.cookies.snowplow.name,
    discoverRootDomain: true,
  });

  if (
    window.__session__ &&
    window.__session__.user &&
    window.__session__.user.id
  ) {
    window.__snowplow__('setUserId', window.__session__.user.id);
  }

  window.__snowplow__('enableActivityTracking:co', 10, 15); // 10s before the first ping, then an interval of 15s

  if (typeof setDomainUserId === 'function') {
    try {
      window.__snowplow__(function () {
        setDomainUserId(this.co.getDomainUserInfo()[1]);
      });
    } catch {
      /* do nothing */
    }
  }
}

export default init;
